const wrapper = "_xkbw19lc6l5";

export { wrapper };
import "./comp.root.style.linaria.module.css";
//# sourceMappingURL=comp.root.style.js.map
